export enum ActivityPriorityType {
  AdminMustAttend = 1,
  PriorityRoster,
  TeacherRequested,
  RegularRoster,
  OptionalRoster,
  AdvertiseActivity,
  NormalActivity
}
